<mat-checkbox
  [aria-label]="input.placeholder | parse: context | async"
  [formControl]="_formControl"
  [labelPosition]="input.labelPosition"
  [required]="input.required"
  [indeterminate]="input.indeterminate | parse: context | async"
>
  @if (input.label | parse: context | async; as label) {
    <mat-label>{{ label }}</mat-label>
  }
</mat-checkbox>
@if (firstFormControlError; as error) {
  <mat-error>
    {{ error.errorMessage | parse: context | async }}
  </mat-error>
}
